import { render } from "./ModalDialog.vue?vue&type=template&id=54b17b92&scoped=true&ts=true"
import script from "./ModalDialog.vue?vue&type=script&lang=ts"
export * from "./ModalDialog.vue?vue&type=script&lang=ts"

import "./ModalDialog.vue?vue&type=style&index=0&id=54b17b92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b17b92"]])

export default __exports__